module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./node_modules/readable-stream/transform.js
// module id = ./node_modules/readable-stream/transform.js
// module chunks = vendor